import { TypeAnimation } from 'react-type-animation';

const TypingEffect = ({ text }) => {
    return (
        <TypeAnimation
            sequence={[
                text,
                "MASTER PANEL",
                500, // wait 1s before replacing "Mice" with "Hamsters"
            ]}
            wrapper="span"
            speed={600}
            style={{ display: 'inline-block' }}
            repeat={Infinity}
        />
    );
};

export default TypingEffect